import React, { Component } from 'react'
import { VictoryLabel } from 'victory'
/**
 * Chart tooltip flyout component for Victory.js charts
 * Renders a floating tooltip with dark background and white text
 * Positions automatically above chart data points
 */
export default class Flyout extends Component<any> {
  static defaultProps = {
    borderRadius: 3,
    width: 150,
    height: 32,
    padding: 10,
  }

  renderTooltip() {
    const width = this.props.width + this.props.padding * 2
    const height = this.props.height
    const y = this.props.y - height - 8
    const x = this.props.x - width / 2
    const style = {
      fill: '#212B36',
    }
    return (
      <g>
        <rect
          rx={this.props.borderRadius}
          ry={this.props.borderRadius}
          {...{
            style,
            x,
            y,
            width,
            height,
          }}
        />
        <VictoryLabel
          {...this.props}
          y={y}
          dy={height / 2}
          text={this.props.text[0]}
          textAnchor="middle"
          verticalAnchor="middle"
          style={{
            fill: '#fff',
            fontFamily: 'inherit',
            fontSize: 12,
          }}
        />
      </g>
    )
  }

  render() {
    return this.renderTooltip()
  }
}
